var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo } from "react";
import { Tooltip, Grid, Stack, Button, SheetContainer, Text, Icon, ListItem, } from "@bookingcom/bui-react";
import { CheckmarkIcon } from "@bookingcom/bui-assets-react/streamline";
import { constructPickerRows, getSelectedItem, prepareSelectionItems, } from "./Picker.utilities";
import "./Picker.types";
import styles from "./Picker.module.css";
function Picker(props) {
    var children = props.children, selection = props.selection, selectedId = props.selectedId, renderSign = props.renderSign, renderSelectedSign = props.renderSelectedSign, multilineItems = props.multilineItems, attributes = props.attributes, triggerAttributes = props.triggerAttributes, onOpen = props.onOpen, onClose = props.onClose;
    var selected = getSelectedItem(selection, selectedId);
    var _a = React.useState(false), modalActive = _a[0], setModalActive = _a[1];
    var closeAttributes = useMemo(function () { return ({
        "data-testid": "selection-modal-close",
    }); }, []);
    if (!selected)
        return null;
    var open = function () {
        if (selection.onOpen)
            selection.onOpen();
        if (onOpen)
            onOpen();
        setModalActive(true);
    };
    var close = function () {
        if (onClose)
            onClose();
        setModalActive(false);
    };
    var handleItemChoose = function (item, index) {
        selection.onChoose(item, index);
        close();
    };
    var Section = function (_a) {
        var sectionIndex = _a.sectionIndex, section = _a.section, isTitleVisible = _a.isTitleVisible, shouldExcludeSelected = _a.shouldExcludeSelected;
        var items = useMemo(function () {
            return prepareSelectionItems(section.items, selectedId, shouldExcludeSelected);
        }, [section.items, shouldExcludeSelected]);
        var rows = useMemo(function () { return constructPickerRows(items); }, [items]);
        if (!items.length)
            return null;
        return (React.createElement(Stack, { gap: 2, attributes: { "data-testid": section.title } },
            isTitleVisible && (React.createElement(Text, { variant: "strong_2", tagName: "h3" }, section.title)),
            React.createElement("div", { className: styles["selection-list"] },
                React.createElement(Stack, { gap: 2 }, rows.map(function (row, index) { return (React.createElement(Grid, { size: "small", tagName: "ul", key: row.length ? row[0].id : index }, row.map(function (item) {
                    var active = selectedId === item.id;
                    var endSlot = active ? (React.createElement(Icon, { svg: CheckmarkIcon, size: "medium" })) : null;
                    return (React.createElement(Grid.Column, { size: 3, key: item.id, tagName: "li" },
                        React.createElement(ListItem, { roundedCorners: true, key: item.id, startSlot: !multilineItems && renderSign(item), endSlot: endSlot, active: selectedId === item.id, href: item.href, spacing: "small", attributes: {
                                "data-testid": "selection-item",
                            }, onClick: function () { return handleItemChoose(item, sectionIndex); } },
                            React.createElement("span", { className: styles["selection-text"] },
                                item.title,
                                multilineItems && renderSign(item)))));
                }))); })))));
    };
    var popularSection = selection.popular && (React.createElement(Section, { sectionIndex: 0, section: selection.popular, isTitleVisible: true, shouldExcludeSelected: true }));
    return (React.createElement(React.Fragment, null,
        React.createElement(Tooltip, { text: selection.title, position: "bottom", hideArrow: true }, function (tooltipAttributes) { return (React.createElement(Button, { variant: "tertiary-inherit", size: "large", onClick: open, attributes: __assign(__assign({}, tooltipAttributes), triggerAttributes) }, children ||
            (renderSelectedSign
                ? renderSelectedSign(selected)
                : renderSign(selected)))); }),
        React.createElement(SheetContainer, { arrowNavigation: true, position: "center", size: 960, title: selection.title, ariaLabel: selection.title, closeAriaLabel: selection.closeAriaLabel, active: modalActive, attributes: __assign({ "data-testid": "selection-modal" }, attributes), closeAttributes: closeAttributes, onCloseTrigger: close },
            React.createElement(Stack, { gap: 4 },
                selection.disclaimer,
                popularSection,
                React.createElement(Section, { sectionIndex: 1, section: selection.all, isTitleVisible: !!popularSection })))));
}
export default Picker;
